export const productDetailsAccordion = () => {
  const faq = document.querySelector(".details-accordions");
  if (!faq) return;

  const faqItemHeight = faq.getAttribute("data-faq-item-height");
  const faqItems = faq.querySelectorAll(".details-accordion");

  const updateAccordionHeight = (accordion) => {
    accordion.style.height = "auto";
    requestAnimationFrame(() => {
      const newHeight = accordion.scrollHeight + "px";
      accordion.style.height = newHeight;
    });
  };

  const toggleFaq = (item) => {
    const isOpened = item.classList.contains("opened");

    faqItems.forEach((elem) => {
      if (elem !== item) {
        elem.classList.remove("opened");
        elem.style.height = `${faqItemHeight}px`;
      }
    });

    if (!isOpened) {
      item.classList.add("opened");
      item.style.height = "auto";
      updateAccordionHeight(item);

      const accordionPosition = item.getBoundingClientRect().top;
      const headerHeight = 100;
      const isInViewport =
        accordionPosition >= headerHeight &&
        accordionPosition <= window.innerHeight - headerHeight;

      if (!isInViewport) {
        window.scrollTo({
          top: window.pageYOffset + accordionPosition - headerHeight,
          behavior: "auto",
        });
      }
    } else {
      item.classList.remove("opened");
      item.style.height = `${faqItemHeight}px`;
    }
  };

  const setupExpandableItems = (accordion) => {
    const expandableItems = accordion.querySelectorAll(".expandable-item");
    const expandableContents = accordion.querySelectorAll(
      ".expandable-content"
    );

    if (expandableItems.length === 0 || expandableContents.length === 0) return;

    expandableItems.forEach((item) => {
      item.addEventListener("click", () => {
        const targetId = item.getAttribute("data-expandable");

        expandableItems.forEach((el) => el.classList.remove("active"));
        expandableContents.forEach((el) => el.classList.remove("active"));

        item.classList.add("active");
        const targetContent = accordion.querySelector(
          `[data-expandable-content="${targetId}"]`
        );

        if (targetContent) {
          targetContent.classList.add("active");

          const openedAccordion = item.closest(".details-accordion.opened");
          if (openedAccordion) {
            updateAccordionHeight(openedAccordion);
          }
        }
      });
    });
  };

  faqItems.forEach((item) => {
    const header = item.querySelector(".details-accordion__header");
    if (header) {
      header.addEventListener("click", (e) => {
        if (!e.target.closest(".expandable-item")) {
          toggleFaq(item);
        }
      });
    }

    if (item.querySelector(".expandable-items")) {
      setupExpandableItems(item);
    }
  });
};
